module.exports = __webpack_public_path__ + "img/adopciones.992c0c6a.jpg";